import { Link } from "react-router-dom";

const ServiceCard = ({
  imageUrl,
  title,
  buttonText = "View Details",
  link,
}) => {
  return (
    <Link to={link}>
      <div className="group relative h-96 cursor-pointer overflow-hidden">
        <img
          src={imageUrl}
          alt={title}
          className="w-full h-full object-cover object-center transform transition-all duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-black/40 transition-all duration-300 group-hover:bg-black/20" />
        <div className="absolute bottom-0 left-0 right-0 p-6 text-white flex justify-center flex-col">
          <h3 className="text-2xl font-bold mb-2 truncate-text">{title}</h3>
          <button className="opacity-100 group-hover:opacity-0 group-hover:-translate-y-4 transition-all duration-300 px-6 py-2 bg-[#cc673d] border-[#cc673d] text-white backdrop-blur-sm">
            {buttonText}
          </button>
        </div>
      </div>
    </Link>
  );
};

export default ServiceCard;
